import familiadosApiClient from '$utils/familiadosApiClient'
import { apiErrorService } from '$utils/services/apiErrorService'
import { CaretakerLocationDto } from '$domain/model/caretaker/caretakersLocation/caretakersLocation.model'
import { apiRouter } from '$domain/model/apiRouter'
import {
  mapToCaretakersLocation,
  mapCaretakerAvailableCareType,
} from '$domain/model/caretaker/caretakersLocation/caretakersLocation.mapper'

export const getCaretakersLocation = async (
  latitude: number,
  longitude: number,
  limit?: number,
  offset?: number,
  caretakerAvailableCareType?: string[],
) => {
  try {
    const caretakersLocation = await familiadosApiClient.get<CaretakerLocationDto[]>(
      apiRouter.getCaretakersLocationPath(),
      {
        latitude,
        longitude,
        limit,
        offset,
        caretakerAvailableCareType: mapCaretakerAvailableCareType(caretakerAvailableCareType),
      },
    )
    return mapToCaretakersLocation(caretakersLocation)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakersLocation/caretakersLocation.manager.ts